<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="stt" label="Tên tuyến xe" outlined required dense hide-details class="font-size" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="licensePlate" label="Biển số xe" outlined dense hide-details class="font-size" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="driver" label="Tên tài xế" outlined required dense hide-details class="font-size" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="driverLicense"
              :items="trueFalseData"
              @change="
                data => {
                  valueChange('driverLicense', data)
                }
              "
              label="Giấy phép lái xe"
              item-text="text"
              item-value="value"
              clearable
              clear-icon="mdi-close"
              dense
              outlined
              return-object
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="resume"
              :items="trueFalseData"
              @change="
                data => {
                  valueChange('resume', data)
                }
              "
              label="Sơ yếu lý lịch"
              item-text="text"
              item-value="value"
              clearable
              clear-icon="mdi-close"
              dense
              outlined
              return-object
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="healthCertificate"
              :items="trueFalseData"
              @change="
                data => {
                  valueChange('healthCertificate', data)
                }
              "
              label="Giấy khám sức khỏe"
              item-text="text"
              item-value="value"
              clearable
              clear-icon="mdi-close"
              dense
              outlined
              return-object
              hide-details
            />
          </v-col>
          <v-col cols="12" md="12">
            <div class="d-flex align-end justify-end">
              <v-btn outlined class="search-button" @click="onFilterChanged">
                Tìm kiếm
              </v-btn>
            </div>
            <v-spacer />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  data() {
    return {
      stt: '',
      licensePlate: '',
      driver: '',
      healthCertificate: null,
      driverLicense: null,
      resume: null,
      cccd: null,
      trueFalseData: [
        {
          text: 'Đủ',
          value: true
        },
        {
          text: 'Chưa có',
          value: false
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      fetch: 'busInformation/fetch',
      count: 'busInformation/count'
    }),
    ...mapMutations({
      setState: 'busInformation/setState'
    }),
    async onFilterChanged() {
      try {
        this.setState({ attribute: 'loading', data: true })
        const params = {
          stt_contains: this.stt,
          licensePlate_contains: this.licensePlate,
          driver_contains: this.driver,
          cccd: this.cccd,
          resume: this.resume,
          healthCertificate: this.healthCertificate,
          driverLicense: this.driverLicense
        }

        await this.fetch(params)
        await this.count(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ attribute: 'loading', data: false })
      }
    },
    valueChange(attribute, data) {
      this[attribute] = data.value
    }
  }
}
</script>

<style></style>
